export enum STEPS {
  IDLE,
  SIGN_IN,
  SIGN_UP,
  INVOICE_DETAILS,
  PAY_AS_GUEST,
}
